import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=71c22ba0&scoped=true&"
import script from "./DataCard.vue?vue&type=script&lang=js&"
export * from "./DataCard.vue?vue&type=script&lang=js&"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=71c22ba0&prod&scoped=true&lang=scss&"
import style1 from "./DataCard.vue?vue&type=style&index=1&id=71c22ba0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c22ba0",
  null
  
)

export default component.exports